import { inject, Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NotificationService implements OnInit {
    private _http: HttpClient = inject(HttpClient)
    private baseuRL = environment.url;
    constructor() { }

    ngOnInit(): void { }

    getRequireActions(collectionName: 'shipment' | 'booking') {
        return this._http.get(`${this.baseuRL}/${collectionName}/get-required-action/shipment/olp`).pipe(
            map((result: any) => result.data)
        )
    }

    getLengthOfRequiredActions() {
        return forkJoin({
            shipment: this.getRequireActions('shipment'),
            booking: this.getRequireActions('booking'),
        }).pipe(
            map(({ shipment, booking }: any) => [...shipment, ...booking].length),
        );
    }
}
